export default __webpack_public_path__ + "static/media/photo.cb128c43.svg";